import { WishlistsStorefrontValuesBrandingEntity } from "@apps/wishlist/entities/WishlistsStorefrontValuesBrandingEntity";
import { InjectionKey } from "@lib/svelte-typed-context";

export const wishlistThemeContextToken: InjectionKey<WishlistsStorefrontValuesBrandingEntity> =
    Symbol("wishlistThemeContext");
